import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import useStyleOrganization from './useStyleOrganizations'
import OrganizationTable from './TableNavigable/TableNavigable'
import { useParams } from 'react-router-dom'
import { getUserLoginAccountWithID } from '../../../app/services/LoginAccount/getLoginAccountWithId'
import { getDataUserOrganization } from '../../../app/services/Organization/getUserDataOrganizationCorpEntities'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import {
  SnackBarError,
  SnackBarSuccess
} from '../../../components/SnackBars/SnackBars'
import InfoIcon from '@mui/icons-material/Info'

export default function OrganizationsOfUser () {
  const classes = useStyleOrganization()
  const { id } = useParams()
  const [user, setuser] = useState(null)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)

  const getUser = async () => {
    try {
      const response = await getUserLoginAccountWithID(id)
      setuser(response.data.loginAccount)
      return response.data.loginAccount
    } catch (error) {
      return null
    }
  }

  const getUserOrganization = async () => {
    try {
      const response = await getUser()

      if (
        response.organizationUsers &&
        response.organizationUsers?.length > 0
      ) {
        await handleGetOrgs(response.organizationUsers)
      }
    } catch (error) {
      setRows([])
    }
  }

  const handleGetOrgs = async (data) => {
    try {
      data.map(async (org) => await handlegetorgRequest(org.userId))
    } catch (error) {
      setRows([])
    }
  }

  const handlegetorgRequest = async (userId) => {
    try {
      const response = await getDataUserOrganization(userId)
      setRows((oldState) => [...oldState, response.data?.data])
    } catch (error) {}
  }

  useEffect(async () => {
    setLoading(true)
    setRows([])
    await getUserOrganization()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent
        name={user ? user.firstName + ' ' + user.lastName : ''}
      />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Organizaciones asociadas al usuario{' '}
          {user && user.firstName + ' ' + user.lastName}
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá visualizar y gestionar las organizaciones del
          usuario {user && user.firstName + ' ' + user.lastName}.
        </Typography>
      </div>

      <SnackBarSuccess />
      <SnackBarError />
      <div className={classes.boxTable}>
        <OrganizationTable
          rows={rows}
          setRows={setRows}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
